import { render, staticRenderFns } from "./announce_procedure_buy_declined.vue?vue&type=template&id=52cd27aa&"
import script from "./announce_procedure_buy_declined.vue?vue&type=script&lang=js&"
export * from "./announce_procedure_buy_declined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports